module.exports = __webpack_public_path__ + "img/gpu_cover_d.8a61c655.png";